// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"118b7cc3","328":"79c1e994","486":"79c1e994","517":"79c1e994","523":"79c1e994","661":"79c1e994","681":"79c1e994","829":"f2bc685a"}[chunkId] + ".chunk.css";
};